import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePortfolioData } from '../contexts/DataContext';
import { Heart, Code } from 'lucide-react';

const getL = (obj, lang) => {
  if (!obj) return '';
  if (typeof obj === 'string') return obj;
  return obj[lang] || obj['pt-BR'] || '';
};

const Footer = () => {
  const { currentLanguage } = useLanguage();
  const { contactInfo } = usePortfolioData();

  const footerText = { 'pt-BR': 'Desenvolvido com', 'en': 'Built with', 'it': 'Realizzato con' };
  const tagline = { 'pt-BR': 'Transformando ideias em soluções robustas há mais de 15 anos', 'en': 'Transforming ideas into robust solutions for over 15 years', 'it': 'Trasformando idee in soluzioni robuste da oltre 15 anni' };

  return (
    <footer data-testid="footer" className="bg-gray-950 border-t border-gray-800 py-12">
      <div className="container max-w-7xl mx-auto px-8">
        <div className="grid md:grid-cols-3 gap-8 items-center">
          <div>
            <div className="text-3xl font-black text-lime-400 mb-2">JPB</div>
            <p className="text-gray-400 text-sm">João Paulo Belatto</p>
            <p className="text-gray-500 text-xs">Software Engineer & Systems Analyst</p>
          </div>
          <div className="text-center">
            <div className="flex items-center justify-center space-x-2 text-gray-400 text-sm">
              <span>{footerText[currentLanguage]}</span><Heart className="text-red-500" size={14} /><span>&</span><Code className="text-lime-400" size={14} />
            </div>
            <p className="text-gray-500 text-xs mt-2">React | Supabase</p>
          </div>
          <div className="text-right md:text-right text-center">
            <p className="text-gray-400 text-sm">&copy; {new Date().getFullYear()} João Paulo Belatto</p>
            <p className="text-gray-500 text-xs">{getL(contactInfo?.location, currentLanguage)}</p>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-500 text-xs">{tagline[currentLanguage]}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
